module.exports = __webpack_public_path__ + "media/images/common/h3_mobile-d46ca2335a894a8daf614e6318ce7d77.gif";